import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { PLAN_NAMES } from "@Shared/@Utils/constants";
import { ACCOUNT_EXPIRATION_DATE, CURRENT_ACCOUNT_PLAN, CURRENT_USER_USERNAME, CURRENT_ACCOUNT_DETAILS } from "@Broker/@Modules/main/store/account/account-getters";
import { mapGetters } from "vuex";
import ProfileAvatar from "@Shared/components/general/profile-avatar.vue";
import { HAS_PAYMENT_ERROR, IS_CURRENT_USER_PAYER, IS_CURRENT_USER_SUBSCRIBED, PAYER, RETRY_PAYMENT_URL } from "../../store/account-plan-getters";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  components: {
    ProfileAvatar
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("AccountStore", [CURRENT_ACCOUNT_DETAILS, CURRENT_USER_USERNAME, CURRENT_ACCOUNT_PLAN, ACCOUNT_EXPIRATION_DATE])), mapGetters("AccountPlanStore", [IS_CURRENT_USER_PAYER, PAYER, IS_CURRENT_USER_SUBSCRIBED, HAS_PAYMENT_ERROR, RETRY_PAYMENT_URL])), {}, {
    isFreeTrial() {
      return this.CURRENT_ACCOUNT_PLAN === PLAN_NAMES.FREE && this.ACCOUNT_EXPIRATION_DATE;
    },
    computedAccountPlan() {
      return this.isFreeTrial ? "freeTrial" : this.CURRENT_ACCOUNT_PLAN;
    },
    accountPlanTitle() {
      const titleMap = {
        freeTrial: "account.accountPlan.freeTrial.title",
        free: "account.accountPlan.free.title",
        professional: "account.accountPlan.professionalPlan.title"
      };
      return this.$t(titleMap[this.computedAccountPlan]);
    },
    accountPlanSubTitlePath() {
      if (this.HAS_PAYMENT_ERROR) return "account.accountPlan.paymentError";
      if (this.CURRENT_ACCOUNT_PLAN === PLAN_NAMES.PRO && !this.IS_CURRENT_USER_SUBSCRIBED) return "account.accountPlan.yourSubscriptionWillEnd";
      const expirationMap = {
        freeTrial: "account.accountPlan.freeTrial.subTitle",
        free: "account.accountPlan.free.subTitle",
        professional: this.IS_CURRENT_USER_PAYER ? "account.accountPlan.professionalPlan.subTitlePayer" : "account.accountPlan.professionalPlan.subTitleNoPayer"
      };
      return expirationMap[this.computedAccountPlan];
    },
    isBroker() {
      return this.CURRENT_ACCOUNT_DETAILS.accountType === "broker";
    },
    showPayerInfo() {
      return !(this.IS_CURRENT_USER_PAYER || isEmpty(this.PAYER));
    }
  })
});